import { connect } from 'react-redux'

import { doActivateCardTab } from 'actions/embeddable_cards'

import {
  selectFindCardsSortedByPosition,
  selectActiveCardTab,
} from 'selectors/embeddable_cards'
import { selectIsTicketSelectionMode } from 'selectors/ticket_list'
import { selectCurrentTicketUndecorated } from 'selectors/tickets'

import { TICKET_SIDEBAR_TAB } from 'constants/context_locations'

import ExpandedContent from './view'

const select = state => {
  const activeCardTab = selectActiveCardTab(state)
  const tabCards = selectFindCardsSortedByPosition(state)(TICKET_SIDEBAR_TAB)
  const isBulkSelectionMode = selectIsTicketSelectionMode(state)
  const ticket = selectCurrentTicketUndecorated(state)

  const showTabs = ticket && !isBulkSelectionMode
  const activeTabIsActive = tabCards.find(card => {
    return card.tabTitle && card.key === activeCardTab
  })
  const showTicketLocation = showTabs && (!activeCardTab || !activeTabIsActive)

  return {
    showTicketLocation,
  }
}

const perform = {
  activateTab: doActivateCardTab,
}

export default connect(select, perform)(ExpandedContent)
